<template>

    <trax-ui-ajax-form-in-modal :id="id" :toastr-id="toastrId" :endpoint="endpoint" 
        :props="props" :titles="titles" :bus="bus" :form="form" icons="1">

        <trax-ui-input type="text" icon="text_fields" :placeholder="lang.polaris.form.name"
            v-model="form.name" :error="errors.name" required="1">
        </trax-ui-input>

        <trax-ui-input type="text" icon="text_fields" rows="3" :placeholder="lang.polaris.form.description"
            v-model="form.description" :error="errors.description">
        </trax-ui-input>

        <trax-ui-select icon="cached" v-model="form.status" :options="status_select">
        </trax-ui-select>

        <div class="mt-5 pl-3 text-left">
            <div v-for="(color, index) in color_values" :key="index" class="row">
                <div class="col-3">
                    <label :class="'btn btn-round btn-'+color+' active'" v-html="index + 1">
                    </label>
                </div>
                <div class="col-6">
                    <trax-ui-select v-model="color_values[index]" :options="color_select" @input="updateScale">
                    </trax-ui-select>
                </div>
                <div class="col-3">
                </div>
            </div>
        </div>

    </trax-ui-ajax-form-in-modal>
    
</template>

<script>
    export default {

        props: ['bus', 'id', 'toastrId', 'endpoint'],
    
        data: function() {
            return {
                lang: lang,
                form: {},
                errors: {},
                status_select: data.status_select,
                props: {
                    id: { source:'id' },
                    name: { source:'name' },
                    description: { source:'description' },
                    status: { source:'status', default:'draft' },
                    colors: { source:'colors', default:['danger', 'warning', 'success'] },
                },
                titles: {
                    new: lang.polaris.training.new_rating,
                    duplicate: lang.polaris.training.rating_duplicate,
                    update: lang.polaris.training.rating_update
                },
                color_select: [
                    { name: 'No more level', value: null },
                    { name: 'Red', value: 'danger' },
                    { name: 'Orange', value: 'warning' },
                    { name: 'Green', value: 'success' },
                ],
                color_values: []
            }
        },

        created: function() {
            var that = this;

            this.bus.$on(that.id+'-errors', function(errors) {
                that.errors = errors;
            });

            this.bus.$on(that.id+'-data', function(data) {
                that.setData(data)
            });

            this.bus.$on(that.id+'-data-duplicate', function(data) {
                that.setData(data)
                that.form.name += ' (' + lang.polaris.training.copy + ')';
                that.form.status = 'draft';
            });
        },

        methods: {
            setData(data) {
                this.form = data;
                this.color_values = []
                for (var index in this.form.colors) {
                    var color = this.form.colors[index]
                    this.color_values.push(color)
                }
                if (this.color_values.length < 5) {
                    this.color_values.push(null)
                }
            },

            updateScale() {
                this.form.colors = []
                for (var index in this.color_values) {
                    var color = this.color_values[index]
                    if (!color) {
                        this.setData(this.form)
                        return;
                    }
                    this.form.colors.push(color)
                }
                if (this.color_values.length < 5) {
                    this.color_values.push(null)
                }
            }
        }
    }
</script>

<style scoped>

    label {
        color: white !important;
    }
    label.btn-success {
        background-color: #4caf50 !important;
    }
    label.btn-warning {
        background-color: #ff9800 !important;
    }
    label.btn-danger {
        background-color: #f44336 !important;
    }
    label.btn-null {
        background-color: white !important;
    }
    
</style>